import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Disclaimer from './views/Disclaimer.vue';
import Privacy from './views/Privacy.vue';
import Terms from './views/Terms.vue';
import Refunds from './views/Refunds.vue';
import ThankYou from './views/ThankYou.vue';
// import Login from './views/Login.vue';
// import Signup from './views/Signup.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: Disclaimer
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/refunds',
      name: 'refunds',
      component: Refunds
    },
    {
      path: '/success',
      name: 'success',
      component: ThankYou
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },
    // {
    //   path: '/signup',
    //   name: 'signup',
    //   component: Signup
    // }
  ],
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  mode: 'history'
});
